<template>
  <v-dialog
    v-model="splitDialog"
    persistent
    hide-overlay
    max-width="800px"
    transition="dialog-center-transition"
    lazy
  >
    <v-card>
      <v-toolbar dark color="#A377FF">
        <v-toolbar-title class="m-0 white--text"
          >Dados do Split para a Usina {{ powerPlantId }}</v-toolbar-title
        >
        <v-spacer />
        <v-toolbar-items>
          <v-btn icon dark flat @click="setSplitDialog(false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <v-autocomplete
                v-model.lazy="partner"
                label="Parceiro"
                :items="partners"
                item-text="name"
                return-object
                :rules="[(v) => !!v || 'Por favor, selecione o Parceiro!']"
                required
              />
            </v-flex>
            <v-flex xs12 sm6 md5>
              <v-layout align-center justify-center row>
                <v-flex md10>
                  <v-autocomplete
                    v-model.lazy="bankAccount"
                    label="Conta Bancaria"
                    :items="recipients"
                    :item-text="bankText"
                    item-value="id"
                    return-object
                    :rules="[
                      (v) => !!v || 'Por favor, selecione a conta Bancaria!',
                    ]"
                    required
                    :disabled="recipientsLoading"
                  />
                </v-flex>
                <v-flex md1>
                  <v-progress-circular
                    indeterminate
                    color="#A377FF"
                    size="20"
                    v-if="recipientsLoading"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                v-model="percentage"
                label="Porcentagem*"
                type="number"
                :rules="[
                  (v) => !!v || 'A porcentagem deve ser maior que 0 (zero)',
                  (v) => v > 0 || 'A porcentagem deve ser maior que 0 (zero)!',
                  (v) =>
                    v <= allowPercentage ||
                    'A porcentagem deve ser menor ou igual a ' +
                      allowPercentage +
                      '%!',
                ]"
                required
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-checkbox
                v-model="liable"
                label="Assume Riscos de chargeback"
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-checkbox
                v-model="charge_processing_fee"
                label="Assume Taxas de Transação"
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-checkbox
                v-model="charge_remainder"
                label="Pagar os eventuais restos das taxas"
              />
            </v-flex>
            <v-flex xs12 sm12 md12 class="text-xs-right">
              <v-spacer />
              <v-btn
                flat
                color="success"
                :disabled="loading || !valid"
                :loading="loading"
                @click.prevent="validate"
                >Salvar</v-btn
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";

export default {
  props: {
    powerPlantId: {
      type: String,
      default: null,
    },
    split: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    rules: [],
    valid: false,
    loading: false,
    recipientsLoading: false,
    liable: true,
    charge_processing_fee: true,
    charge_remainder: true,
    partner: null,
    bankAccount: null,
    percentage: 100,
    allowPercentage: 0,
    recipients: [],
  }),

  computed: {
    ...mapState("configuration", ["splitDialog", "partners"]),
    ...mapGetters("configuration", ["filteredRecipients"]),

    bankAccounts() {
      return this.partner.bankAccounts ?? [];
    },
  },

  watch: {
    partner() {
      this.recipientsLoading = true;
      this.recipients = this.filteredRecipients(this.bankAccounts);
      this.bankAccount =
        this.recipients.length === 1 ? this.recipients[0] : null;
      this.recipientsLoading = false;
    },
  },

  methods: {
    ...mapActions("configuration", [
      "getPartners",
      "getRecipientsByAccount",
      "addSplit",
      "getAllRecipients",
    ]),
    ...mapMutations("configuration", ["setSplitDialog"]),

    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const newSplit = {
          recipient_id: this.bankAccount.id,
          percentage: +this.percentage, // o + converte para number
          liable: this.liable,
          charge_processing_fee: this.charge_processing_fee,
          charge_remainder: this.charge_remainder,
          partner: this.partner.id,
        };
        const split = this.split.map((item) => item);

        await this.addSplit({
          powerPlantId: this.powerPlantId,
          split,
          newSplit,
        });
        this.loading = false;
      }
      this.setSplitDialog(false);
    },

    bankText(item) {
      return `${
        item.bank_account && item.bank_account.legal_name
          ? item.bank_account.legal_name
          : ""
      }`;
    },
  },

  mounted() {
    this.getPartners();
    this.getAllRecipients();

    if (this.split.length > 0) {
      for (const account of this.split) {
        this.percentage -= account.percentage;
      }
      this.allowPercentage = this.percentage;
    } else {
      this.allowPercentage = 100;
    }
  },
};
</script>
